(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/compare-games/assets/javascripts/compare-games.js') >= 0) return;  svs.modules.push('/components/tur/compare-games/assets/javascripts/compare-games.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.compare_games = svs.tur.compare_games || {};
svs.tur.compare_games.init = () => {
  const unfilteredSections = document.querySelectorAll('[data-gameinfo-unfiltered]');
  const filteredSections = document.querySelectorAll('[data-gameinfo-filtered]');
  const filteredJackpotSections = document.querySelectorAll('[data-gameinfo-filtered-jackpot]');
  const filterButtons = document.querySelectorAll('[data-type="compare-games-filter-button"]');
  const gameInfoUsps = document.querySelectorAll('[data-gameinfo-usp]');
  const trackFilterClick = (buttonLabel, pos) => {
    svs.components.analytics.trackEvent({
      action: 'Filter',
      category: 'Compare Games',
      opt_label: buttonLabel,
      opt_value: pos
    });
  };
  const setButtonStyles = filterType => {
    filterButtons.forEach(button => {
      if (button.getAttribute('data-compare-type') === filterType) {
        button.classList.add('btn-inverted');
        button.classList.remove('btn-transparent-default');
      } else {
        button.classList.add('btn-transparent-default');
        button.classList.remove('btn-inverted');
      }
    });
  };

  const setSectionAndUspVisibility = filterType => {
    unfilteredSections.forEach(section => {
      if (filterType === 'overview') {
        section.classList.remove('u-hide');
      } else {
        section.classList.add('u-hide');
      }
    });
    filteredSections.forEach(section => {
      if (filterType === 'overview' || filterType === 'jackpot') {
        section.classList.add('u-hide');
      } else {
        section.classList.remove('u-hide');
      }
    });
    filteredJackpotSections.forEach(section => {
      if (filterType === 'jackpot') {
        section.classList.remove('u-hide');
      } else {
        section.classList.add('u-hide');
      }
    });
    gameInfoUsps.forEach(usp => {
      if (filterType === 'overview') {
        usp.classList.remove('u-hide');
      } else {
        usp.classList.add('u-hide');
      }
    });
  };

  const filterGames = filterType => {
    const filteredGameInfo = document.querySelectorAll('[data-gameinfo-filtered] [data-gameinfo]');
    const filteredJackpotGameInfo = document.querySelectorAll('[data-gameinfo-filtered-jackpot] [data-gameinfo]');
    filteredJackpotGameInfo.forEach(game => {
      if (game.getAttribute('data-compare-type') === filterType) {
        game.classList.remove('u-hide');
      } else {
        game.classList.add('u-hide');
      }
    });
    filteredGameInfo.forEach(game => {
      if (game.getAttribute('data-compare-type') === filterType) {
        game.classList.remove('u-hide');
      } else {
        game.classList.add('u-hide');
      }
    });
  };
  filterButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      const filterType = button.getAttribute('data-compare-type');
      const buttonLabel = button.innerHTML;
      setButtonStyles(filterType);
      setSectionAndUspVisibility(filterType);
      filterGames(filterType);
      trackFilterClick(buttonLabel, index + 1);
    });
  });
};

 })(window);